import { jsx as _jsx } from "react/jsx-runtime";
/* eslint-disable fp/no-mutation */
import { toDays, toHours, toMinutes, toSeconds } from 'duration-fns';
import { hasDuration } from '../deliveryEstimationService';
import translate from '../translate';
import { DAYS, HOURS, MINUTES, SECONDS, PREFIX_IN, PREFIX_WITHIN } from './constants';
import { getTranslationKey, } from './translationKeyService';
export function convertDurationToMaximumUnits(duration) {
    const numberDays = toDays(duration);
    const numberHours = toHours(duration);
    if (numberDays >= 1 || numberHours > 23) {
        return { total: Math.ceil(numberDays), units: DAYS };
    }
    const numberMinutes = toMinutes(duration);
    if (numberHours >= 1 || numberMinutes > 59) {
        return { total: Math.ceil(numberHours), units: HOURS };
    }
    const numberSeconds = toSeconds(duration);
    if (numberMinutes >= 1 || numberSeconds > 59) {
        return { total: Math.ceil(numberMinutes), units: MINUTES };
    }
    return { total: Math.ceil(numberSeconds), units: SECONDS };
}
export function hasAbsoluteDeliveryEstimate(deliveryEstimation) {
    const duration = deliveryEstimation.duration || {};
    if (duration.min && duration.max) {
        const min = convertDurationToMaximumUnits(duration.min);
        const max = convertDurationToMaximumUnits(duration.max);
        if (min.units === max.units && min.total === max.total) {
            return true;
        }
    }
    return false;
}
export function getTranslation(durationString, isBusiness, isRange, prefix) {
    const durationObject = convertDurationToMaximumUnits(durationString);
    const translationKey = getTranslationKey(durationObject.units, isBusiness, isRange, prefix);
    return { key: translationKey, params: { [durationObject.units]: durationObject.total } };
}
export function getTranslationForRange(duration, isBusiness, prefix) {
    const min = convertDurationToMaximumUnits(duration.min);
    const max = convertDurationToMaximumUnits(duration.max);
    if (max.units === min.units) {
        return {
            key: getTranslationKey(max.units, isBusiness, true, prefix),
            params: { min: min.total, max: max.total },
        };
    }
    return getTranslation(duration.max, isBusiness, false, PREFIX_WITHIN);
}
export const formatDeliveryEstimation = (deliveryEstimation, { lang = 'en', translationOptions = {}, }, { showAsBusiness = false, includePrefix = true, isSpeedFormat = false } = {}) => {
    let translation;
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    const isBusiness = showAsBusiness &&
        (!hasDuration(deliveryEstimation) || (deliveryEstimation === null || deliveryEstimation === void 0 ? void 0 : deliveryEstimation.durationType) === 'BUSINESS');
    if (!(deliveryEstimation === null || deliveryEstimation === void 0 ? void 0 : deliveryEstimation.providerGivesEstimate)) {
        translation = {
            key: isSpeedFormat ? 'unavailable' : 'delivery-estimation.provider-does-not-give-estimate',
            params: {},
        };
    }
    else if (!hasDuration(deliveryEstimation)) {
        translation = { key: 'delivery-estimation.not-yet-collected', params: {} };
    }
    else if (hasAbsoluteDeliveryEstimate(deliveryEstimation)) {
        translation = getTranslation(deliveryEstimation.duration.min, isBusiness, false, includePrefix ? PREFIX_IN : undefined);
    }
    else if (deliveryEstimation.duration.min && deliveryEstimation.duration.max) {
        translation = getTranslationForRange(deliveryEstimation.duration, isBusiness, includePrefix ? PREFIX_IN : undefined);
    }
    else if (deliveryEstimation.duration.max) {
        translation = getTranslation(deliveryEstimation.duration.max, isBusiness, false, PREFIX_WITHIN);
        // eslint-disable-next-line sonarjs/no-duplicated-branches
    }
    else {
        translation = getTranslation(deliveryEstimation.duration.min, isBusiness, false, includePrefix ? PREFIX_IN : undefined);
    }
    if (translationOptions.keySuffix) {
        translation = Object.assign(Object.assign({}, translation), { key: `${translation.key}.${translationOptions.keySuffix}` });
    }
    const translationParams = translationOptions.params || {};
    return translate(translation.key, lang, Object.assign(Object.assign(Object.assign({}, translation.params), translationParams), { span: (chunks) => (_jsx("span", Object.assign({ className: translationParams.estimationClassNames }, { children: chunks }))) }));
};
